import { Component, ViewChild, Injector, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { GetHoldiayPolicyForViewDto, HoldiayPolicyDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
    selector: 'viewHoldiayPolicyModal',
    templateUrl: './view-holdiayPolicy-modal.component.html'
})
export class ViewHoldiayPolicyModalComponent extends AppComponentBase {

    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    item: GetHoldiayPolicyForViewDto;


    constructor(
        injector: Injector
    ) {
        super(injector);
        this.item = new GetHoldiayPolicyForViewDto();
        this.item.holdiayPolicy = new HoldiayPolicyDto();
    }

    show(item: GetHoldiayPolicyForViewDto): void {
        this.item = item;
        this.active = true;
        this.modal.show();
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
